import { render, staticRenderFns } from "./NsProductVariantSelector.vue?vue&type=template&id=4ccb9764&scoped=true&"
import script from "./NsProductVariantSelector.vue?vue&type=script&lang=js&"
export * from "./NsProductVariantSelector.vue?vue&type=script&lang=js&"
import style0 from "./NsProductVariantSelector.vue?vue&type=style&index=0&id=4ccb9764&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ccb9764",
  null
  
)

export default component.exports